module.exports = __webpack_public_path__ + "img/coned.2d3ffec1.jpg";